import { render, staticRenderFns } from "./ImfMstLocationList.vue?vue&type=template&id=651d0e55&"
import script from "./ImfMstLocationList.vue?vue&type=script&lang=js&"
export * from "./ImfMstLocationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports